(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  let collectionListSlider = new Swiper(".collection-list-slider", {
      slidesPerView: 2,
      spaceBetween: 12,
      navigation: {
        nextEl: ".collection-list-button-next",
        prevEl: ".collection-list-button-prev",
      },
      breakpoints: {
        481: {
          slidesPerView: 2.8
        },
        750: {
          slidesPerView: 3.5
        },
        990: {
          slidesPerView: 4.8
        },
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-banner"] && !Shopify.designMode) return;
  try {
    
  var cibSwiper = new Swiper(".custom-image-banner-swiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".banner-button-next",
      prevEl: ".banner-button-prev",
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enhance-wellness"] && !Shopify.designMode) return;
  try {
    
  let ewswiperInstance = null;

  function ewhandleSwiperClass() {
    const ewslider = document.querySelector("#enhance-wellness-swiper");

    if (!ewslider) return;

    if (window.innerWidth <= 989) {
      ewslider.classList.add("enhance-wellness-swiper");

      // Only initialize if not already
      if (!ewswiperInstance) {
        ewswiperInstance = new Swiper(".enhance-wellness-swiper", {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl: ".enhance-wellness-button-next",
            prevEl: ".enhance-wellness-button-prev",
          },
          breakpoints: {
            576: {
              slidesPerView: 2
            }
          },
        });
      }
    } else {
      ewslider.classList.remove("enhance-wellness-swiper");

      // Destroy Swiper if it exists
      if (ewswiperInstance) {
        ewswiperInstance.destroy(true, true);
        ewswiperInstance = null;
      }
    }
  }

  // Run on load
  ewhandleSwiperClass();

  // Run on resize
  window.addEventListener("resize", ewhandleSwiperClass);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  let featuredCollectionSlider = new Swiper(".featred-collection-slider", {
      slidesPerView: 2,
      spaceBetween: 12,
      navigation: {
        nextEl: ".featured-collection-button-next",
        prevEl: ".featured-collection-button-prev",
      },
      breakpoints: {
        461: {
          slidesPerView: 2
        },
        750: {
          slidesPerView: 3
        },
        990: {
          slidesPerView: 4
        },
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-benefits"] && !Shopify.designMode) return;
  try {
    
  let hbswiperInstance = null;

  function hbhandleSwiperClass() {
    const hbslider = document.querySelector("#health-benefits-swiper");

    if (!hbslider) return;

    if (window.innerWidth <= 989) {
      hbslider.classList.add("health-benefits-swiper");

      // Only initialize if not already
      if (!hbswiperInstance) {
        hbswiperInstance = new Swiper(".health-benefits-swiper", {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl: ".health-benefits-button-next",
            prevEl: ".health-benefits-button-prev",
          },
          breakpoints: {
            361: {
              slidesPerView: 1.2
            },
            401: {
              slidesPerView: 1.3
            },
            481: {
              slidesPerView: 1.5
            },
            576: {
              slidesPerView: 2
            },
            841: {
              slidesPerView: 2.5
            },
          },
        });
      }
    } else {
      hbslider.classList.remove("health-benefits-swiper");

      // Destroy Swiper if it exists
      if (hbswiperInstance) {
        hbswiperInstance.destroy(true, true);
        hbswiperInstance = null;
      }
    }
  }

  // Run on load
  hbhandleSwiperClass();

  // Run on resize
  window.addEventListener("resize", hbhandleSwiperClass);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Make review count clickable (links to reviews section)
  const badge = document.querySelector('.custom-product-wrapper .product__info-wrapper .jdgm-prev-badge');
  if (badge) {
    var reviewText = badge.querySelector('.jdgm-prev-badge__text');
    if (reviewText && !reviewText.closest('a')) {
      var reviewLink = document.createElement('a');
      reviewLink.href = '#product-review';
      reviewLink.style.cssText = 'color:inherit;text-decoration:underline;cursor:pointer;';
      reviewText.parentNode.insertBefore(reviewLink, reviewText);
      reviewLink.appendChild(reviewText);
    }
  }

  const smarterrOptions = document.querySelectorAll('div[data-smartrr-selling-plan-group-id]');
  const iconTextContainer = document.getElementById('custom-icons-with-text-container');
  
  smarterrOptions.forEach(function(options) {
   const attrValue = options.getAttribute("data-smartrr-selling-plan-group-id");
    options.addEventListener('click', function() {
      if(options.classList.contains('smartrr-group-active')){
          if(attrValue.length > 0) {
          setTimeout(() => {
            iconTextContainer.style.display = 'block';
          },200);
        }
      } else{
        setTimeout(() => {
          iconTextContainer.style.display = 'none';
        },200);
      }
    });
  });
  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premier-choice"] && !Shopify.designMode) return;
  try {
    
  let pcswiperInstance = null;

  function pchandleSwiperClass() {
    const pcslider = document.querySelector("#premier-choice-swiper");

    if (!pcslider) return;

    if (window.innerWidth <= 989) {
      pcslider.classList.add("premier-choice-swiper");

      // Only initialize if not already
      if (!pcswiperInstance) {
        pcswiperInstance = new Swiper(".premier-choice-swiper", {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl: ".premier-choice-button-next",
            prevEl: ".premier-choice-button-prev",
          }
        });
      }
    } else {
      pcslider.classList.remove("premier-choice-swiper");

      // Destroy Swiper if it exists
      if (pcswiperInstance) {
        pcswiperInstance.destroy(true, true);
        pcswiperInstance = null;
      }
    }
  }

  // Run on load
  pchandleSwiperClass();

  // Run on resize
  window.addEventListener("resize", pchandleSwiperClass);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["transparency"] && !Shopify.designMode) return;
  try {
    
  let transparencySlider = new Swiper(".transparency-slider", {
      slidesPerView: 1,
      spaceBetween: 12,
      navigation: {
        nextEl: ".transparency-button-next",
        prevEl: ".transparency-button-prev",
      },
      breakpoints: {
        461: {
          slidesPerView: 2
        },
        750: {
          slidesPerView: 3
        },
        990: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 5
        },
      },
      on: {
        init: function () {
          toggleNavigation(this);
        },
        resize: function () {
          toggleNavigation(this);
        }
      }
  });
  function toggleNavigation(swiper) {
    const nav = document.querySelector('.transparency-navigation-button');
    if (!nav) return;

    // Only show buttons if scrolling is possible
    if (swiper.slides.length > swiper.params.slidesPerView) {
      nav.style.display = 'flex';
    } else {
      nav.style.display = 'none';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
